// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-selector {
  position: relative;
}

.current-language {
  font-family: var(--font-mono);
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.06em;
}

.language-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 1100;
  list-style: none;
  min-width: 13rem;
  max-height: min(70vh, 30rem);
  overflow-y: auto;
  padding: 0.3rem 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-sm);
  box-shadow: 0 10px 30px var(--shadow-primary);
}

.language-option {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  min-height: 40px;
  padding: 0.45rem 0.9rem;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.95rem;
  text-align: left;
}

.language-option:hover {
  background: var(--bg-tertiary);
}

.language-option.active {
  color: var(--accent-primary);
}

.language-code {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  width: 1.6rem;
  color: var(--text-tertiary);
}

.language-option.active .language-code {
  color: var(--accent-primary);
}

/* Flaggen */
.flag {
  flex-shrink: 0;
  border-radius: 2px;
  box-shadow: 0 0 0 1px var(--border-secondary);
}

.icon-btn.current-language {
  width: auto;
  gap: 0.4rem;
  padding-inline: 0.55rem;
}

.language-option.active {
  background: var(--accent-soft);
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguageSelector.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,yCAAyC;EACzC,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".language-selector {\n  position: relative;\n}\n\n.current-language {\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n}\n\n.language-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 1100;\n  list-style: none;\n  min-width: 13rem;\n  max-height: min(70vh, 30rem);\n  overflow-y: auto;\n  padding: 0.3rem 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-sm);\n  box-shadow: 0 10px 30px var(--shadow-primary);\n}\n\n.language-option {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  width: 100%;\n  min-height: 40px;\n  padding: 0.45rem 0.9rem;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  text-align: left;\n}\n\n.language-option:hover {\n  background: var(--bg-tertiary);\n}\n\n.language-option.active {\n  color: var(--accent-primary);\n}\n\n.language-code {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  width: 1.6rem;\n  color: var(--text-tertiary);\n}\n\n.language-option.active .language-code {\n  color: var(--accent-primary);\n}\n\n/* Flaggen */\n.flag {\n  flex-shrink: 0;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px var(--border-secondary);\n}\n\n.icon-btn.current-language {\n  width: auto;\n  gap: 0.4rem;\n  padding-inline: 0.55rem;\n}\n\n.language-option.active {\n  background: var(--accent-soft);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
